import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SeoMetaProps {
  title: string;
  description: string;
  canonical?: string;
  image?: string;
  url?: string;
  noIndex?: boolean;
  preloadImage?: string;
  fetchPriority?: 'high' | 'low' | 'auto';
}

export const SeoMeta: React.FC<SeoMetaProps> = ({
  title,
  description,
  canonical,
  image = 'https://planoo.com.au/assets/og-image.png',
  url,
  noIndex = false,
  preloadImage,
  fetchPriority,
}) => {
  const isProduction =
    typeof window !== 'undefined' &&
    ['planoo.com.au', 'www.planoo.com.au'].includes(window.location.hostname);
  const shouldNoIndex = noIndex || !isProduction;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}
      {preloadImage && (
        <link
          rel="preload"
          as="image"
          href={preloadImage}
          type="image/webp"
          {...(fetchPriority ? ({ fetchpriority: fetchPriority } as any) : {})}
        />
      )}
      {shouldNoIndex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
